import styled from 'styled-components';

export const StyledLLCSection = styled.div`
  background: url('https://media.appcharge.com/defaults/llc-section-img.png')
    center;
  background-size: cover;
  margin-top: 8px;
  margin-bottom: 5px;
  width: 297px;
  height: 61px;
  display: flex;
  align-items: center;
  justify-content: center;

  .section-text {
    font-size: 20px;
  }

  .section-image {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;

    .image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .section-name {
    max-width: 185px;
    font-family: 'Lemon Milk';
    margin: 0 6px;
    background: linear-gradient(180deg, #9c87c7 20%, #fff 80%);
    background-clip: text;
    -webkit-text-stroke-width: 0.5px;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.6);
    -webkit-background-clip: text;
    color: #ffff;
    @supports (
      background: linear-gradient(180deg, #9c87c7 20%, #fff 80%) text
    ) {
      -webkit-text-fill-color: transparent;
    }
    filter: drop-shadow(0 2px 2px rgba(4, 0, 26, 0.9));
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 1.6px;
    text-transform: uppercase;
  }
` as any;
